import { Inject } from '@odinjs/odin';
import Controller, { OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import { PainScaleAPI } from '@philips-emr/health-professional-components/src/components';
import { AdaptedFacesPainScaleAliases, FragmentNames } from '../../../codegen';

interface ContextDataProps {
  data: {
    setPainScaleValue: (value: number) => void;
  }
}

@Controller({ fragment: FragmentNames.ADAPTED_FACES_PAIN_SCALE })
class AdaptedFacesController extends BaseController {

  @Inject(AdaptedFacesPainScaleAliases.PAIN_SCALE_ADAPTED_FACES)
    painScaleApi!: PainScaleAPI;

  @OnUnmount(AdaptedFacesPainScaleAliases.PAIN_SCALE_ADAPTED_FACES)
  onLayoutUnmount(): void {
    if (this.painScaleApi.getValue()) {
      const { data: { setPainScaleValue } } = this.context as unknown as ContextDataProps;
      setPainScaleValue(Number(this.painScaleApi.getValue()));
    }
  }
}
export default AdaptedFacesController;
